import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-inventory-article-search',
  templateUrl: './inventory-article-search.component.html',
  styleUrls: ['./inventory-article-search.component.css']
})
export class InventoryArticleSearchComponent implements OnInit {
    public searchTextButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('searchtext') },
        { id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.loadArticles() }
    ];

    public setting?: Setting;

    public itemsListArticles: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(948))[0];
    }

    private async loadArticles() {
        if (!this.setting) return;

        return this.itemsListArticles = await this.datatask.Post(949, this.setting);
    }

    public searchArticles() {
        this.loadArticles();
    }

    private clear(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                this.setting.searchtext = '';
                this.itemsListArticles = [];
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'only_on_stock':
                this.loadArticles();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadArticles();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockcount_keyno: string;
    stocklocation_keyno: string;
    stocklocation_description: string;
    stockplace_id: string;
    searchtext: string;
    show_setting: string;
    only_on_stock: string;
}
